import { V3HeadlineH4 } from "../Typography"
import { V3EmbedUnavailableWrapper } from "./V3EmbedUnavailable.styles"

interface V3EmbedUnavailableProps { }

export const V3EmbedUnavailable = ({ }: V3EmbedUnavailableProps) => {
    return <V3EmbedUnavailableWrapper>
        <V3HeadlineH4>Looks like this embed is no longer available.</V3HeadlineH4>
    </V3EmbedUnavailableWrapper>
}